<template>
    <div v-if="show">
        <div class="footer">
            <div class="box" v-for='(item,index) of items' :class='[item.cls,{on:index === idx}]'  @click.stop="change(item.push,index)">
                <div >
                    <img v-bind:src="'../static/images/caidan/'+item.icon+item.icon_unclick+'.png '">
                </div>
                <p :class="['colorChange',{on:index===idx}]" >{{item.name}}</p>
            </div>
        </div>
        <div class="go_home" @click="to_home()">
            <span class="el-icon-s-home"></span>
        </div>
    </div>

</template>

<script type="text/javascript">
    export default{
        name: 'ChildFooter26',
        // props:['idx'],
        data(){
            return {
                show:true,
                idx:0,
                items:[
                    {
                        cls:"child_sand",
                        name:"沙盘",
                        push:"/childsand26",
                        icon_unclick:2,
                        icon:'sp'
                     },
                    {
                        cls:"Massif",
                        name:"建筑",
                        push:"/Massif26",
                        icon_unclick:1,
                        icon:'jingzhuang'
                    },
                    {
                        cls:"distribution",
                        name:"户型",
                        push:"/distribution26",
                        icon_unclick:1,
                        icon:'hx',
                    },
                    {
                        cls:"roam",
                        name:"景观",
                        push:"/roam26",
                        icon_unclick:1,
                        icon:'jg',
                    },
                    {
                        cls:"hardcover",
                        name:"生活体验馆",
                        push:"/hardcover26",
                        icon_unclick:1,
                        icon:'jianzhu',
                    },
                    // {
                    //     cls:"mine",
                    //     name:"个人中心",
                    //     push:"/childuser",
                    //     icon:'el-icon-user',
                    // }
                ]
            }
        },
        mounted(){
            var paths=["/childsand26",'/massif26','/distribution26','/roam26','/hardcover26','/Massif26'];
            if (paths.indexOf(this.$route.path)>-1){
                this.show=true
            }else {
                this.show=false
            }
            console.log(this.$route.path)
            this.items.forEach((e,i)=>{
                if (this.$route.path==e.push){
                    this.idx=i
                }
            })
        },
        watch:{
            $route(to,from){
                var paths=["/childsand26",'/massif26','/distribution26','/roam26','/hardcover26','/Massif26'];
                console.log(this.$route.path);
                if (this.$route.path=="/childsand26"){
                    this.show=true
                }else if(this.$route.path=="/"){
                    this.show=false
                }
            }
        },
        methods:{
            // drag:function(event){    //接收事件对象
            //     dom = event.currentTarget;
            // },
            change(push,index){
                this.$router.push(push);
                this.idx=index;
                for (var i=0;i<this.items.length;i++) {

                    if(i==index){
                        this.items[i].icon_unclick=2;

                    }else{
                        this.items[i].icon_unclick=1;


                    }

                }
            },
            to_home(){
                this.$router.push('/');
            }

        }

    }
</script>
<style lang="scss" scoped>
    .footer{

        display: flex; justify-content: space-between;
        position: fixed;
        left: 0;
        bottom: 0;
        background: url("../../static/images/caidan/dt.png")no-repeat;background-size: 100%;
        width: 100%;
        z-index:99;


    }
    .box{
        cursor: pointer;
        flex: 1;
        margin: auto 0;width: 20%; height: 100%; font-size: 1.2rem; color: #555454; text-align: center;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
        -webkit-tap-highlight-color:transparent;

    }
    img{
        width: 100%;
    }
    .box>div{
        margin: 0 auto 6px auto; width: 20px; height: 20px;
        font-size: 20px;
    }
    div p{
        color: #ffffff;
        font-size:12px;
        font-family: "微软雅黑";
    }
    .on{
        color:#1C86EE;
    }
    .go_home{
        position: fixed;
        bottom: 14%;
        right: 2%;
        z-index: 20;

        color: #000;
    }
    .go_home  span{
        background: #f2f2f2;
        border-radius: 50%;
        padding: 6px;
        opacity: 0.6;
        font-size:18px;
        color: #0f4ce7;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/ChildFooter26.vue